import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AttentionModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  emits: ["close", "proceed"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const close = () => {
    emits("close");
  };
  const proceed = () => {
    emits("proceed");
  };

const __returned__ = { emits, props, close, proceed, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})